import { IUseTrialActivationModal } from "components/kelas-live/trial-activation-modal/trial-activation-modal.types";
import {
  DaySchedule,
  Sessions
} from "hooks/use-live-classes/use-live-classes.types";
import { IGetFeedbackForUserResponse } from "services/api/nps/npsService.types";
import {
  ClassSession,
  ISessionModalConfigurationResponseWithAPIandState,
  UpcomingClassSession
} from "services/api/sessions/sessionService.types";

export enum ClassSessionType {
  ONGOING = "ongoing",
  UPCOMING = "upcoming"
}

export type ITrialActivationProps = Pick<
  IUseTrialActivationModal,
  | "activationState"
  | "setActivationState"
  | "showTrialActivationComponent"
  | "activateTrial"
  | "handleActivationStates"
  | "showTrialActivation"
  | "setShowTrialActivation"
>;

export type IFeedbackTrialClassDataObject = Partial<
  IGetFeedbackForUserResponse["data"]
> & { id: string };
export type IUseUserLanding = ITrialActivationProps & {
  getJoinLinkURL: (classID: string) => void;
  onGoingClasses: ClassSession[] | null;
  upcomingClasses: UpcomingClassSession | null;
  modalClassSession: ClassSession | null;
  setClassSessionModalDetails: (
    classSession: ClassSession | null,
    classType: ClassSessionType | null
  ) => void;
  modalType: ClassSessionType | null;
  showJoiningClassPopUp: boolean;
  sessions: Sessions;
  mediaBaseUrl: string | null;
  currentTimeStamp: string | null;
  handleJoinClass: (classSession: ClassSession) => void;
  isNpsModalOpen: boolean;
  feedbackTrialClassDataObject: IFeedbackTrialClassDataObject | null;
  handleNpsModalClose: () => void;
  routeToWeeklySchedulePage: () => void;
  isFetchingSessions: boolean;
  openQnALink: (classID: string) => void;
  modalConfiguration: ISessionModalConfigurationResponseWithAPIandState;
  updateModalConfigurationThankyouScreen: () => void;
  classSchedule: DaySchedule[];
};
